import { Link } from 'react-router-dom';
import { Aperture } from 'lucide-react';
import { useCurrentUser } from '@/hooks/useAuth';
import { Button } from '@/components/ui/Button';

/** Top bar of the pages that can be read without an account (competition announcement, user guide). */
export function PublicHeader() {
  const { isAuthenticated } = useCurrentUser();

  return (
    <header className="border-b border-line bg-surface-1">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-3">
        <Link to="/" className="flex items-center gap-2">
          <Aperture size={22} aria-hidden="true" />
          <span className="font-display text-xl font-semibold tracking-tight">Zaslonka</span>
        </Link>
        <nav className="flex items-center gap-2">
          <Link to="/navodila-za-uporabo" className="hidden text-sm text-fg-secondary hover:text-fg hover:underline sm:inline">
            Navodila za uporabo
          </Link>
          <Link to={isAuthenticated ? '/' : '/login'}>
            <Button variant="secondary" size="sm">
              {isAuthenticated ? 'Odpri aplikacijo' : 'Prijava'}
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
}
